import _Promise from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/promise';
import Vue from 'vue';
import NuxtLoading from './components/nuxt-loading.vue';

import '../node_modules/bootstrap/dist/css/bootstrap.css';

import '../assets/css/main.css';

import '../node_modules/vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.min.css';

import '../node_modules/vue-upload-component/dist/vue-upload-component.part.css';

import '../node_modules/vue-simple-calendar/static/css/default.css';

var layouts = {

  "_dashBoardLayout": function _dashBoardLayout() {
    return import('../layouts/dashBoardLayout.vue' /* webpackChunkName: "layouts/dashBoardLayout" */).then(function (m) {
      return m.default || m;
    });
  },

  "_default": function _default() {
    return import('../layouts/default.vue' /* webpackChunkName: "layouts/default" */).then(function (m) {
      return m.default || m;
    });
  },

  "_mianPage": function _mianPage() {
    return import('../layouts/mianPage.vue' /* webpackChunkName: "layouts/mianPage" */).then(function (m) {
      return m.default || m;
    });
  }

};

var resolvedLayouts = {};

export default {
  head: { "title": "Training-Booking", "meta": [{ "charset": "utf-8" }, { "name": "viewport", "content": "width=device-width, initial-scale=1" }, { "hid": "description", "name": "description", "content": "Nuxt.js project" }], "link": [{ "rel": "icon", "type": 'image/x-icon', "href": '/newLogo.ico' }, { "rel": "", "type": "javascript", "href": "" }], "script": [{ "src": 'https://unpkg.com/xlsx/dist/shim.min.js' }, { "src": 'https://unpkg.com/xlsx/dist/xlsx.full.min.js' }, { "src": "" }], "style": [] },
  render: function render(h, props) {
    var loadingEl = h('nuxt-loading', { ref: 'loading' });
    var layoutEl = h(this.layout || 'nuxt');
    var templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl]);

    var transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      }
    }, [templateEl]);

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl]);
  },

  data: function data() {
    return {
      layout: null,
      layoutName: ''
    };
  },
  beforeCreate: function beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt);
  },
  created: function created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this;
    // add to window so we can listen when ready
    if (typeof window !== 'undefined') {
      window.$nuxt = this;
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error;
  },
  mounted: function mounted() {
    this.$loading = this.$refs.loading;
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  methods: {
    errorChanged: function errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail();
        if (this.$loading.finish) this.$loading.finish();
      }
    },
    setLayout: function setLayout(layout) {
      if (!layout || !resolvedLayouts['_' + layout]) layout = 'default';
      this.layoutName = layout;
      var _layout = '_' + layout;
      this.layout = resolvedLayouts[_layout];
      return this.layout;
    },
    loadLayout: function loadLayout(layout) {
      var _this = this;

      if (!layout || !(layouts['_' + layout] || resolvedLayouts['_' + layout])) layout = 'default';
      var _layout = '_' + layout;
      if (resolvedLayouts[_layout]) {
        return _Promise.resolve(resolvedLayouts[_layout]);
      }
      return layouts[_layout]().then(function (Component) {
        resolvedLayouts[_layout] = Component;
        delete layouts[_layout];
        return resolvedLayouts[_layout];
      }).catch(function (e) {
        if (_this.$nuxt) {
          return _this.$nuxt.error({ statusCode: 500, message: e.message });
        }
      });
    }
  },
  components: {
    NuxtLoading: NuxtLoading
  }
};


//////////////////
// WEBPACK FOOTER
// ./.nuxt/App.js
// module id = ./.nuxt/App.js
// module chunks = 20